import { render, staticRenderFns } from "./SpecificExaminationsDictionary.vue?vue&type=template&id=2463359e&lang=pug&"
import script from "./SpecificExaminationsDictionary.vue?vue&type=script&lang=js&"
export * from "./SpecificExaminationsDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports